// Consulter une section (culturel, economie, sport)
import React from 'react';
import SectionList from './SectionList';

const SectionConsulter = ({
  category = 'culturel',
  sectionTitle = 'Culturel',
  emptyLabel = 'Aucun contenu culturel',
}) => {
  return (
    <div className="presse-page">
      <SectionList
        category={category}
        sectionTitle={sectionTitle}
        emptyLabel={emptyLabel}
      />
    </div>
  );
};

export default SectionConsulter;
